"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Monographs = void 0;
const store_1 = require("client/modules/orders/store");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const react_1 = require("react");
const React = require("react");
require("./monographs.less");
const filteredAttr = [
    "adverse_reactions_table",
    "clinical_studies_table",
    "dosage_and_administration_table",
    "how_supplied_table",
    "id",
    "openfda",
    "set_id",
    "spl_product_data_elements",
    "version",
    "warnings_table"
];
let Monographs = class Monographs extends react_1.Component {
    // @observable monograph: any = {};
    constructor(props) {
        super(props);
        this.renderCallFDA = () => (React.createElement("tr", null,
            React.createElement("td", { className: "center" },
                React.createElement("b", null, "Call your doctor for medical advice about side effects. You may report side effects to FDA at 1-800-FDA-1088"))));
        this.renderBody = (inventory) => {
            const hasData = Object.keys(this.props.monograph).length !== 0;
            let result = {};
            if (hasData) {
                result = this.props.monograph.results[0];
            }
            return (React.createElement("tr", null,
                React.createElement("td", { className: "wide" },
                    React.createElement("br", null),
                    "IMPORTANT: HOW TO USE THIS INFORMATION: This is a summary and does NOT have all possible information about this product. This information does not assure that this product is safe, effective, or appropriate for you. This information is not individual medical advice and does not substitute for the advice of your health care professional. Always ask your health care professional for complete information about this product and your specific health needs.",
                    React.createElement("br", null),
                    React.createElement("br", null),
                    hasData ? result.openfda.generic_name : "",
                    React.createElement("br", null),
                    hasData ? `COMMON BRAND NAME(S): ${result.openfda.brand_name}` : "",
                    Object.keys(result)
                        .filter((e) => !filteredAttr.includes(e) && !e.includes("table"))
                        .map((e, index) => {
                        const text = Array.isArray(result[e])
                            ? result[e].join(" ")
                            : result[e];
                        let textStr = text.toString();
                        let attr = e.split("_").join(" ");
                        const noTitle = textStr.search(new RegExp(attr, "i")) === -1;
                        if (attr === "effective time") {
                            textStr = moment(textStr).format("MM/DD/YYYY");
                        }
                        else {
                            textStr = textStr.replace(/^\d+\.*\d*\s*/, "");
                        }
                        if (noTitle) {
                            attr = `${attr.toUpperCase()}: `;
                            textStr = attr.concat(textStr);
                        }
                        return (React.createElement("div", { key: index },
                            React.createElement("br", null),
                            textStr.replace("Section Text", "")));
                    }))));
        };
    }
    render() {
        const claim = store_1.ordersStore.claim.value;
        const inventory = claim && claim.inventory;
        return (React.createElement("div", { className: "monographs" },
            React.createElement("table", { className: "wide" },
                React.createElement("tbody", null,
                    this.renderCallFDA(),
                    React.createElement("tr", null,
                        React.createElement("td", { className: "center" },
                            React.createElement("b", null,
                                "1Patient Information for:",
                                " ",
                                React.createElement("span", { className: "uppercase" }, inventory &&
                                    `${inventory.name} ${inventory.strength} ${inventory.unit}`)))),
                    inventory && this.renderBody(inventory)))));
    }
};
Monographs = __decorate([
    mobx_react_1.observer
], Monographs);
exports.Monographs = Monographs;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-detail/components/order-claims/monographs/monographs.tsx
// module id = 3730
// module chunks = 0